import { Html, Line } from "@react-three/drei";
import * as THREE from "three";
import { useSceneStore } from "../store/sceneStore";

export function MeasureOverlay() {
  const measurePoints = useSceneStore((s) => s.measurePoints);

  return (
    <>
      {measurePoints.map((mp, i) => (
        <mesh key={i} position={mp.point}>
          <sphereGeometry args={[1, 12, 12]} />
          <meshBasicMaterial color="#5b8cff" depthTest={false} />
        </mesh>
      ))}
      {measurePoints.length === 2 && (
        <MeasureLine a={measurePoints[0].point} b={measurePoints[1].point} />
      )}
    </>
  );
}

function MeasureLine({ a, b }: { a: [number, number, number]; b: [number, number, number] }) {
  const va = new THREE.Vector3(...a);
  const vb = new THREE.Vector3(...b);
  const distance = va.distanceTo(vb);
  const midpoint = va.clone().add(vb).multiplyScalar(0.5);

  return (
    <>
      <Line points={[a, b]} color="#5b8cff" lineWidth={2} depthTest={false} />
      <Html position={midpoint.toArray()} center>
        <div className="measure-label">{distance.toFixed(2)} mm</div>
      </Html>
    </>
  );
}
